import { useEffect } from "react";
import { usuarioObtenerCompaniasYSucursales } from "../../api/usuarios.api";
import { sedesPorCompania } from "../../../sedes";
import { sucursalesPorCompania } from "../../../sucursales";
import { CONST_ROL_MASTER } from "../../../../app/constants/constanst-valores";
import { CONST_RUTA_USUARIOS_LISTAR } from "../../../../app/constants/constants-rutas-codigos";
import { useRefetchAlCerrarModal } from "../../../../shared/hooks/useRefetchAlCerrarModal";

// Filtros del listado de usuarios: catálogos (compañía, sucursal, sede), su
// cascada, la carga inicial al montar, el refresco al cerrar el modal y el
// snapshot de sucursales con que se etiqueta la tabla.
export const useUsuariosFiltros = ({
  usuarioAutenticado,
  rol,
  datosParaBusquedaRapida,
  watch,
  setValue,
  listaSucursales,
  listaUsuarios,
  setListaCompanias,
  setListaSucursales,
  setListaSedes,
  setIsLoadingFiltros,
  setSucursalesTabla,
  setMostrarOpcionTodos,
  obtenerUsuarios,
}: any) => {

  const obtenerCompaniasYSucursales = async () => {

    const dataPOST = {
      token: usuarioAutenticado?.token
    }

    const { companias, sucursales, sedes } = await usuarioObtenerCompaniasYSucursales(dataPOST)

    setListaCompanias(companias)
    setListaSucursales(sucursales)
    setValue("compania", datosParaBusquedaRapida == null ? companias?.[0]?.id : datosParaBusquedaRapida?.codCompania)

    return {
      companias: companias,
      sucursales: sucursales,
      sedes:sedes
    }
  }

  const obtenerSucursalesPorCompaniaPorDefecto = async (idCompania) => {

    const dataPOST = {
      token: usuarioAutenticado?.token,
      Codigo: idCompania,
      Estado: "A"
    }

    const { sucursales } = await sucursalesPorCompania(dataPOST)

    const listaSucursalesFormateada = sucursales?.map(s => ({
      id: s?.CompCod,
      tipo: s?.CompNom
    }))

    setListaSucursales(listaSucursalesFormateada)
    // MASTER: por defecto "TODOS", para ver a los usuarios de todas las sucursales de la compañía.
    setValue("sucursal", datosParaBusquedaRapida == null ? "T" : datosParaBusquedaRapida?.codSucursal)

  }

  // Sucursal "TODOS" ('T'): ListaSede devuelve las sedes de todas las sucursales de la compañía.
  const consultaSedes = (idSucursal) => ({
    compania: idSucursal,
    token: usuarioAutenticado?.token,
    ...(idSucursal === "T" ? { comp_pad: watch("compania") } : {}),
  })

  const obtenerSedesPorSucursalPorDefecto = async (idSucursal) => {

    const { sedes } = await sedesPorCompania(consultaSedes(idSucursal))
    setListaSedes(sedes)
    setValue("Sede", datosParaBusquedaRapida == null ? ("T") : (datosParaBusquedaRapida?.codSede))
    //setValue("Sede", datosParaBusquedaRapida == null ? ("T") : datosParaBusquedaRapida?.codSede)

  }

  const obtenerSucursalesPorCompania = async (idCompania) => {

    const dataPOST = {
      token: usuarioAutenticado?.token,
      Codigo: idCompania,
      Estado: "A"
    }
    const { sucursales } = await sucursalesPorCompania(dataPOST)

    const listaSucursalesFormateada = sucursales?.map(s => ({
      id: s?.CompCod,
      tipo: s?.CompNom
    }))
    setListaSucursales(listaSucursalesFormateada)
    setValue("compania", idCompania)
    setValue("sucursal", rol === CONST_ROL_MASTER ? "T" : sucursales?.[0]?.CompCod)

  }

  const obtenerSedesPorSucursal = async (idCompania) => {

    const { sedes } = await sedesPorCompania(consultaSedes(idCompania))

    setListaSedes(sedes)
    setValue("sucursal", idCompania)
    // datosParaBusquedaRapida ya tiene datosParaBusquedaRapida?.codSede
    //setValue("Sede", sedes?.[0]?.SedCod)
    setValue("Sede", "T")

  }

  useEffect(() => {

    const cargarDatosIniciales = async () => {
      try {
        const { sucursales, sedes } = await obtenerCompaniasYSucursales()
        if (rol === CONST_ROL_MASTER) {
          await obtenerSucursalesPorCompaniaPorDefecto(watch("compania"));

        } else {
          setListaSucursales(sucursales)
          //setValue("sucursal", sucursales?.[0]?.id) //datosParaBusquedaRapida == null ? sucursales?.[0]?.CompCod : datosParaBusquedaRapida?.codSucursal
          setValue("sucursal", datosParaBusquedaRapida == null ? sucursales?.[0]?.id : datosParaBusquedaRapida?.codSucursal) //datosParaBusquedaRapida == null ? sucursales?.[0]?.CompCod : datosParaBusquedaRapida?.codSucursal
        }
        if (sucursales?.length > 1) {
          //console.log("entro al if")
          await obtenerSedesPorSucursalPorDefecto(watch("sucursal"));

        } else {
          //console.log("entro al else")
          const listaSedesFormateada = sedes?.map(s => ({
            SedCod: s?.id,
            SedDesc: s?.tipo
          }))
          setListaSedes(listaSedesFormateada)
          //setValue("Sede", datosParaBusquedaRapida == null ? (listaSedesFormateada?.[0]?.SedCod || "T") : datosParaBusquedaRapida?.codSede)
          setValue("Sede", "T")
          setMostrarOpcionTodos(false)
        }

        obtenerUsuarios()
      } finally {
        // Los selects ya tienen data (o falló): apagamos el indicador de carga de filtros.
        // (obtenerUsuarios ahora sólo fija filtros; la lista carga vía useQuery con su propio isLoading.)
        setIsLoadingFiltros(false)
      }
    };

    cargarDatosIniciales();
    // carga inicial (una sola vez al montar)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // El listado queda montado de fondo cuando se abre el modal (agregar/editar/grupos);
  // al cerrarlo (regreso a la ruta base) se refresca conservando los filtros actuales.
  useRefetchAlCerrarModal(CONST_RUTA_USUARIOS_LISTAR, obtenerUsuarios)

  // Congela las sucursales para etiquetar la tabla SOLO cuando cambian los RESULTADOS
  // (busqueda/carga), no cuando cambia el filtro. Asi la columna "Sucursal" no se vacia al
  // cambiar de Compania sin buscar. Depende de listaUsuarios a proposito.
  useEffect(() => {
    setSucursalesTabla(listaSucursales)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listaUsuarios])

  return { obtenerSucursalesPorCompania, obtenerSedesPorSucursal }
}
